import { render } from "./EditDieselCost.vue?vue&type=template&id=6d24c046&scoped=true"
import script from "./EditDieselCost.vue?vue&type=script&lang=js"
export * from "./EditDieselCost.vue?vue&type=script&lang=js"

import "./EditDieselCost.vue?vue&type=style&index=0&id=6d24c046&scoped=true&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6d24c046"]])

export default __exports__